import { Eyebrow, GoldRule, Reveal } from "./Reveal";

const CHAPTERS = [
  {
    number: "01",
    title: "La Main Française",
    subtitle: "Confection Drôme & broderie Isère",
    text: "Tous nos modèles sont fabriqués en France : la confection se fait dans la Drôme, dans notre atelier Point par Point, et la broderie en Isère, au sein de la société Brod'Art. Le geste textile noble, au service des coiffeurs exigeants.",
  },
  {
    number: "02",
    title: "Le Burlington Oeko Tex",
    subtitle: "Microfibre technique, toucher doux",
    text: "Le tissage microfibre de notre polyester Burlington certifié Oeko Tex ne se décolore pas avec les produits techniques et ne retient pas les cheveux coupés. Son grammage idéal de 110 g/m² : entretien facile, aucune électricité statique, séchage rapide à l'air libre.",
  },
  {
    number: "03",
    title: "La Broderie Signature",
    subtitle: "Votre logo, votre image",
    text: "Faire broder votre logo est une communication à forte valeur ajoutée pour votre salon. Bien plus esthétique, robuste et qualitative qu'un simple flocage — dès 5 pièces, modèles mixables entre eux.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifeste"
      data-testid="manifesto-section"
      className="py-24 sm:py-32 px-6 sm:px-12 lg:px-20 max-w-7xl mx-auto"
    >
      <Reveal>
        <Eyebrow>Le Manifeste</Eyebrow>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-light tracking-tight max-w-2xl">
          Trois serments d'atelier,{" "}
          <em className="italic text-[#D4AF37]">gravés dans l'étoffe</em>.
        </h2>
        <GoldRule className="mt-8" />
      </Reveal>

      <div className="mt-16 grid grid-cols-1 lg:grid-cols-3 gap-8">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.number} delay={i * 0.15}>
            <article
              data-testid={`manifesto-chapter-${c.number}`}
              className="group relative h-full overflow-hidden rounded-2xl bg-[#141619] border border-[#E2DBCB]/10 p-8 sm:p-10 transition-colors duration-300 hover:border-[#D4AF37]/40"
            >
              <span className="font-serif text-6xl sm:text-7xl font-light text-[#D4AF37]/15 transition-colors duration-500 group-hover:text-[#D4AF37]/30">
                {c.number}
              </span>
              <h3 className="mt-6 font-serif text-xl sm:text-2xl font-medium text-[#F7F5F0]">
                {c.title}
              </h3>
              <p className="mt-2 text-xs font-mono uppercase tracking-[0.2em] text-[#C5A059]">
                {c.subtitle}
              </p>
              <p className="mt-6 text-sm leading-relaxed text-[#B0ABA0]">
                {c.text}
              </p>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
